// 世界史スポットデータのバレル。実体は src/sites/ 配下の地域別ファイル。
// （airports.js が airportsCurated.js / airportsData.js をまとめるのと同じ形。）
//
// 収録方針: 日本の高校世界史の教科書・資料集に載る水準の遺跡・建造物を、
//   全有人大陸 × 先史〜近現代でバランスよく収める。1文明あたり原則1〜2件。
//
// 出典: 山川『詳説世界史』の年表 / UNESCO 世界遺産リスト / Wikipedia(ja,en) 相互確認。
//
// 各スポットのレコード:
// {
//   id            一意キー(ASCII kebab-case)。localStorage の訪問記録キーなので
//                 一度使ったら絶対に変更しない（変えると全員の進捗が消える）。
//   name/nameEn   日本語名 / 英語名。モーダル見出しで「日本語名 / English Name」と併記。
//   lat/lng       遺跡そのものの中心座標（都市の代表点ではない）。輪はこの真上に立つ。
//   elevationM    その地点の地表標高(m, 概算)。輪の高さの基準。±50m はズレてよいが、
//                 高地（マチュ・ピチュ 2430m 等）を 0 にすると輪が山中に埋まる。
//   region        REGION_LABELS のキー。
//   era           ERA_LABELS のキー。モーダルのバッジ色に対応。
//   country       現在の国・地域。civilization  文明・王朝・時代区分。
//   yearLabel     表示用の年代文字列。何の年かを必ず明記する（「537年完成」「前2560年頃」）。
//                 1000年以前は原則「〜頃」を付け、「世界最古」等の断定は書かない。
//   whcYear       ユネスコ世界遺産の登録年。対象外・未登録は null。
//   whcNote       任意。登録名がスポット名と異なる場合の補足。
//   facts         任意。追加の事実行 [{ label, value }]（0〜3行）。
//   emoji         ミニマップのマーカーとモーダル見出しに出すアイコン。
//   summary       解説文。日本語 250〜400字。「いつ造られたか → 当時の歴史的文脈 →
//                 世界史の中での意義」の順で書く。固有名詞は教科書表記に合わせる。
//   quiz          ○×クイズ1問 { statement, answer(true=○), explain }。
//                 付けない場合は明示的に null を書く（書き忘れと区別するため）。
//   solemn        任意。追悼施設なら true。原爆ドーム・アウシュヴィッツ・ゴレ島・
//                 真珠湾など、「へえ！」型のクイズも「NEW!」バッジも出さない場所。
//                 solemn を立てたら quiz は必ず null（check.js が検証する）。
//   ringRadiusM   任意。輪の半径(m)の上書き。既定は historicSites.js の RING_RADIUS_M。
//   ringAglM      任意。地表から輪の中心までの高さ(m)の上書き。既定は RING_CENTER_AGL_M。
// }
import { JAPAN_SITES } from './sites/japan.js';
import { ASIA_SITES } from './sites/asia.js';
import { WEST_ASIA_SITES } from './sites/westAsia.js';
import { AFRICA_SITES } from './sites/africa.js';
import { EUROPE_SITES } from './sites/europe.js';
import { AMERICAS_SITES } from './sites/americas.js';
import { OCEANIA_SITES } from './sites/oceania.js';

export const ERA_LABELS = {
  prehistory: '先史',
  ancient: '古代',
  medieval: '中世',
  earlymodern: '近世',
  modern: '近現代',
};

export const REGION_LABELS = {
  japan: '日本',
  asia: 'アジア',
  'west-asia': '西アジア・中央アジア',
  africa: 'アフリカ',
  europe: 'ヨーロッパ',
  americas: 'アメリカ大陸',
  oceania: 'オセアニア・太平洋',
};

export const HISTORIC_SITES = [
  ...JAPAN_SITES,
  ...ASIA_SITES,
  ...WEST_ASIA_SITES,
  ...AFRICA_SITES,
  ...EUROPE_SITES,
  ...AMERICAS_SITES,
  ...OCEANIA_SITES,
];
